import trashicon from "./trashicon.svg";

export default function TrashIcon() {
  return (
    <img src={trashicon} />
  );
}